import { createContext, type ReactNode, useContext } from 'react';
import type { GetEffectiveDimensionsFactory } from '../coordinates/geometry';
import type { TransformContributionWithState } from './transform-composition';

export type DocumentCanvasContextValue = {
  getEffectiveDimensions: GetEffectiveDimensionsFactory;
  transformWrappers: TransformContributionWithState['Wrapper'][];
};

const DocumentCanvasContext = createContext<DocumentCanvasContextValue | null>(
  null
);

export const DocumentCanvasContextProvider = ({
  value,
  children,
}: {
  value: DocumentCanvasContextValue;
  children: ReactNode;
}) => (
  <DocumentCanvasContext.Provider value={value}>
    {children}
  </DocumentCanvasContext.Provider>
);

export const useDocumentCanvasContext = (): DocumentCanvasContextValue => {
  const context = useContext(DocumentCanvasContext);
  if (!context) {
    throw new Error(
      'useDocumentCanvasContext must be used within DocumentCanvasContextProvider'
    );
  }
  return context;
};

export const useTransformWrappers =
  (): TransformContributionWithState['Wrapper'][] => {
    return useDocumentCanvasContext().transformWrappers;
  };
